export default "__VITE_ASSET__DigssL_7__"